import { jsx } from "react/jsx-runtime";
import { ModalContext } from "./hooks/useModalContext.js";
const ModalProvider = ({ value, children }) => {
  return /* @__PURE__ */ jsx(ModalContext.Provider, { value, children });
};
export {
  ModalProvider
};
